<!-- src/components/Sidebar.vue -->
<template>
  <el-aside :width="isCollapsed ? '64px' : '210px'" class="aside">
    <!-- Logo 部分 -->
    <div class="logo">
      <img :src="logoUrl" alt="Logo" class="logo-image" />
      <span v-if="!isCollapsed" class="logo-text">{{ logoTitle }}</span>
    </div>


    <!-- 创建视频按钮 -->
    <div class="create-video-button">
      <el-button type="primary" round size="large" class="custom-button" @click="handleCreateVideo">
        <el-icon class="custom-icon">
          <Plus />
        </el-icon>
        <span v-if="!isCollapsed">创建短视频</span>
      </el-button>
    </div>


    <!-- 导航菜单 -->
    <el-menu :default-active="activeMenu" class="menu" @select="handleMenuSelect" :collapse="isCollapsed"
      collapse-transition :unique-opened="true" router>
      <!-- 形象克隆 -->
      <el-menu-item index="ImageCloning">
        <el-icon>
          <Film />
        </el-icon>
        <span v-if="!isCollapsed">形象克隆</span>
      </el-menu-item>

      <!-- 声音克隆 -->
      <el-menu-item index="VoiceCloning">
        <el-icon>
          <Microphone />
        </el-icon>
        <span v-if="!isCollapsed">声音克隆</span>
      </el-menu-item>

      <!-- 声音合成 -->
      <el-menu-item index="VoiceSynthesis">
        <el-icon>
          <ChatLineRound />
        </el-icon>
        <span v-if="!isCollapsed">声音合成</span>
      </el-menu-item>

      <!-- 数字作品 -->
      <el-menu-item index="DigitalWorks">
        <el-icon>
          <VideoCamera />
        </el-icon>
        <span v-if="!isCollapsed">数字作品</span>
      </el-menu-item>

      <!-- 超能助手 -->
      <el-menu-item index="SuperAssistant">
        <el-icon>
          <Eleme />
        </el-icon>
        <span v-if="!isCollapsed">超能助手</span>
      </el-menu-item>

      <!-- 个人信息 -->
      <!-- <el-menu-item index="UserProfile">
        <el-icon>
          <User />
        </el-icon>
        <span v-if="!isCollapsed">个人信息</span>
      </el-menu-item> -->
      <el-menu-item index="CozeSuper">
        <el-icon>
          <Connection /> <!-- 选择适合的图标 -->
        </el-icon>
        <span v-if="!isCollapsed">扣子智能</span>
      </el-menu-item>
    </el-menu>

    <!-- 折叠按钮 -->
    <div class="toggle-button" @click="toggleAside">
      <el-icon>
        <Fold v-if="!isCollapsed" />
        <Expand v-else />
      </el-icon>
    </div>
  </el-aside>
</template>

<script>
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import axios from 'axios';
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { auth } from '@/utils/auth.js';
import config from '@/config.js'; // 引入配置文件

export default {
  name: 'AppSidebar', // 使用多单词名称以符合 ESLint 规则
  components: {
    ...ElementPlusIconsVue,
  },
  props: {
    isCollapsed: {
      type: Boolean,
      required: true,
    },
    activeMenu: {
      type: String,
      required: true,
    },
  },
  emits: ['toggleAside', 'menuSelect'],
  setup(props, { emit }) {
    const router = useRouter();
    const storeLevel = ref(null); // 存储商户等级
    const logoUrl = ref(''); // 存储 Logo URL
    const logoTitle = ref(''); // 存储 Logo 标题
    // 创建视频按钮点击事件
    const handleCreateVideo = () => {
      router.push({ name: 'CreateVideo' }); // 跳转到创建视频页面
    };

    // 获取当前运行域名
    const getCurrentHost = () => {
      return window.location.origin; // 返回完整域名，例如 "https://example.com"
    };

    // 调用接口获取 Logo 和标题
    const fetchLogoAndTitle = async () => {
      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/get_agent_info.php`, {
          agent_host: getCurrentHost(), // 传递当前域名
        });

        if (response.data.pc_logo) {
          logoUrl.value = response.data.pc_logo; // 更新 Logo
        }
        if (response.data.pc_title) {
          logoTitle.value = response.data.pc_title; // 更新标题
        }
      } catch (error) {
        console.error("获取 Logo 和标题失败:", error);
      }
    };


    // 方法：获取商户信息
    const fetchStoreInfo = async () => {
      try {
        const user = auth.getStoredUser();
        if (!user) {
          ElMessage.error('未登录，请重新登录1');
          router.push('/login');
          return;
        }

        const account = user.account;

        // 发送请求获取商户信息
        const response = await axios.post(
          `${config.BASE_URL}/pc/api/store_api.php`,
          { action: 'query', account: account }
        );

        if (response.data.success) {
          const data = response.data.data;
          // 根据 level 设置 storeLevel
          storeLevel.value = parseInt(data.level, 10) || 0;
        } else {
          ElMessage.error(response.data.message || '查询商户信息失败');
        }
      } catch (error) {
        console.error('查询商户信息失败:', error);
        ElMessage.error('查询商户信息失败，请检查网络连接');
      }
    };

    // 在组件挂载时调用 fetchStoreInfo 方法
    onMounted(() => {
      fetchStoreInfo();
      fetchLogoAndTitle();

    });

    // 处理菜单选择
    const handleMenuSelect = (index) => {
      emit('menuSelect', index);
      router.push({ name: index });
    };

    // 处理侧边栏折叠
    const toggleAside = () => {
      emit('toggleAside');
    };

    return {
      storeLevel,
      logoUrl,
      logoTitle,
      handleMenuSelect,
      toggleAside,
      handleCreateVideo,
    };
  },
};
</script>

<style scoped>
.aside {
  background-color: #fff;
  /* 设置侧边栏背景为白色 */
  color: #000;
  /* 设置默认文本颜色为黑色 */
  position: relative;
  transition: all 0.3s ease-in-out;
  height: 100vh;
  /* 确保侧边栏高度为全屏 */
  border-right: 1px solid #eaeaea;
  /* 添加右侧边框 */
}

.create-video-button {
  margin: 20px 16px;
  /* 按钮上下左右的间距 */
  text-align: center;

}

.create-video-button .custom-button {
  background-color: #ff5c00 !important;
  /* 按钮背景颜色 */
  color: #fff !important;
  /* 按钮文字颜色 */
  border: none !important;
  /* 去掉按钮边框 */
  width: 100%;
  /* 按钮宽度为父容器宽度 */
  height: 50px;
  /* 按钮高度 */
  font-weight: bold;
  font-size: 18px;
  justify-content: center;
  /* 图标居中 */
  display: flex;
  align-items: center;

  border-radius: 8px;
}

.custom-icon {
  font-size: 20px;
  /* 图标大小 */
  font-weight: bold;
  /* 图标加粗 */
}

.create-video-button .custom-button:hover {
  background-color: #e04b00 !important;
  /* 悬停时的按钮颜色 */
}


.create-video-button .custom-button:focus {
  outline: none;
  box-shadow: none;
}

.logo {
  height: 40px;
  display: flex;
  align-items: center;

  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px 20px;
}

.logo-image {
  width: 40px;
  height: 40px;
}

.logo-text {
  margin-left: 10px;
  opacity: 1;
  transition: all 0.3s ease;
  color: #000;
  /* 设置Logo文本颜色为黑色 */
  font-size: 20px;
  font-weight: bold;
}

.menu {}

.el-menu {
  border-right: none
    /* 添加右侧边框 */
}

.menu .el-menu-item {
  font-size: 18px;
  font-family: 'PingFang HK', sans-serif;
  font-weight: bold;
  display: flex;
  align-items: center;
  padding: 12px 36px;
  transition: all 0.3s ease;
  color: #000;
  margin: 8px 0;
  border-radius: 8px;
  justify-content: center;
  /* 图标居中 */

}

.menu .el-menu-item:hover {
  /* 移除悬停时的背景颜色 */
  background-color: transparent;
}

.menu .el-menu-item.is-active {
  background-color: #ffe6cc !important;
  /* 选中时的背景颜色 */
  color: #ff5c00 !important;
  /* 选中时的文本颜色 */
  font-weight: bold;
  /* 选中时的字体加粗 */
  border-radius: 8px;
  /* 添加圆角 */
  margin: 0 8px;
  /* 左右间距 */

  /* 左右间距 */
}

.menu .el-menu-item.is-active .el-icon {
  color: #ff5c00 !important;
  /* 选中时图标颜色 */
}

.menu .el-icon {
  font-size: 24px;
  margin-right: 12px;
  color: #000;
  /* 图标默认颜色 */
}


.toggle-button {
  position: absolute;
  bottom: 20px;
  left: 0;
  width: 100%;
  text-align: center;
  cursor: pointer;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.6);
  /* 折叠按钮颜色 */
  transition: transform 0.3s ease, color 0.3s ease;
}

.toggle-button:hover {
  transform: scale(1.1);
  color: #ff5c00;
  /* 悬停时颜色 */
}

/* 响应式设计 */
@media (max-width: 768px) {
  .logo-text {
    display: none;
  }

  .menu-icon {
    margin-right: 0;
  }

  .menu .el-menu-item span {
    display: none;
  }

  .menu .el-menu-item {
    justify-content: center;
  }
}
</style>
